var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toolbar"},[_c('div',{staticClass:"iconfont icon-cancel",on:{"click":function($event){return _vm.$emit('cancel')}}}),_c('div',{staticClass:"iconfont icon-ok",on:{"click":function($event){return _vm.$emit('ok')}}})])}
var staticRenderFns = []

export { render, staticRenderFns }